import {
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuItemProps,
  MenuList,
} from '@chakra-ui/react';
import React from 'react';

type MenuOption = {
  menuItemProps: MenuItemProps;
  label: string;
};

interface Props {
  menus: MenuOption[];
  menuButtonProps: MenuButtonProps;
}

export const EllipsesButton: React.FC<Props> = ({ menus, menuButtonProps }) => {
  return (
    <div>
      <Menu>
        {/*
         // @ts-ignore TS2590 */}
        <MenuButton {...menuButtonProps}>･･･</MenuButton>
        <MenuList>
          {menus.map((menu, i) => (
            <MenuItem key={i} {...menu.menuItemProps}>
              {menu.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </div>
  );
};
